import type { TrackingContextValue } from '@ps/web-shared-analytics';
import { TrackingCategory, TrackingContext } from '@ps/web-shared-analytics';
import { kebabCase, upperFirst } from 'lodash';
import React, { useRef } from 'react';
import { useSelector, useStore } from 'react-redux';

import VisibilityTracker from '@swf/components/VisibilityTracker/VisibilityTracker';
import StarsWidgetContext from '@swf/core/providers/StarsWidgetContext';
import type { Store } from '@swf/core/store';
import type { WidgetReference } from '@swf/core/types/Widget';
import widgets from '@swf/widgets/index';

const modellessWidgets = [
  'help_bot',
  'legacy_sports',
  'sports_page_not_found',
  'sports_quick_links',
  'sports_self_excluded_info',
  'sports_settings'
];

const StarsWidget: React.FC<WidgetReference> = (widget) => {
  const store = useStore() as Store;
  const { uid, _content_type_uid, title = '' } = widget;
  const trackingEntities = useRef(
    useSelector((state) => store.select[uid]?.getEntities?.(state, widget))
  );
  let category = upperFirst(kebabCase(_content_type_uid).split('-')[0]) as TrackingCategory;
  category = [TrackingCategory.Casino, TrackingCategory.Sports].includes(category)
    ? category
    : TrackingCategory.Stars;

  const { current: trackingContext } = useRef<TrackingContextValue>({
    category,
    widget: { widgetName: title, widgetId: uid }
  });

  const dispatch = store.dispatch[uid];

  if (!(dispatch || modellessWidgets.includes(_content_type_uid))) return null;

  const Widget = widgets[_content_type_uid];

  return (
    // TODO: CMS-migration - investigate context value change in https://git.pyrsoftware.ca/stash/projects/STARSWEB/repos/stars-web-client/pull-requests/12914/overview
    <StarsWidgetContext.Provider value={widget}>
      <TrackingContext.Provider value={trackingContext}>
        <VisibilityTracker
          name={title}
          trackingContext={{ ...trackingContext, entities: trackingEntities.current }}
        >
          <Widget />
        </VisibilityTracker>
      </TrackingContext.Provider>
    </StarsWidgetContext.Provider>
  );
};

export default StarsWidget;
